/**
 * 选择供稿分类弹窗
 * create by lzy 2020.03.17
 */

'use strict';

angular.module('feedPopupModule', []).controller('feedPopupCtrl', ['$scope', '$q', '$modalInstance', 'trsHttpService', 'trsspliceString', 'mediaInfo',
    function($scope, $q, $modalInstance, trsHttpService, trsspliceString, mediaInfo) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.data = {
                list: [], // 请求的分类列表
                selectedArray: [] // 选中的分类列表
            };
        }

        /**
         * [initData description] 初始化数据
         *
         * @return  {[type]}  [return description]
         */
        function initData() {
            request();
        }

        /**
         * [request description] 请求分类数据
         *
         * @return  {[type]}  [return description]
         */
        function request() {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_sharedoc',
                methodName: 'queryGongGaoCategorys'
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.data.list = data;
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [selected description] 列表选中
         *
         * @param   {[type]}  item  [item description] 选中项对象
         *
         * @return  {[type]}        [return description]
         */
        $scope.selected = function(item) {
            var index = $scope.data.selectedArray.indexOf(item);
            if (index === -1) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice(index, 1);
            }
        };

        /**
         *[close description] 取消按钮操作
         * @return  {[type]}  [return description]
         */
        $scope.close = function() {
            $modalInstance.dismiss();
        };
    
        /**
         * [confirm description] 确定按钮操作
         * @return  {[type]}  [return description]
         */
        $scope.confirm = function() {
            var params = {};
            if (mediaInfo.mediaType === '-1') { // -1代表iwo
                params = {
                    serviceid: 'mlf_fusionmyrelease',
                    methodName: 'personalContribution',
                    MetaDataIds: mediaInfo.metadataids,
                    ShareToCats: trsspliceString.spliceString($scope.data.selectedArray, 'SHARECATEGORYID', ','),
                    mediaType: mediaInfo.mediaType,
                    oprType: mediaInfo.oprType
                };
            } else { // 1代表app
                params = {
                    serviceid: 'mlf_appoper',
                    methodName: 'mediaMetaDataContribution',
                    MetaDataIds: mediaInfo.metadataids,
                    ShareToCats: trsspliceString.spliceString($scope.data.selectedArray, 'SHARECATEGORYID', ','),
                    mediaType: mediaInfo.mediaType,
                    ChannelId: mediaInfo.channelId
                };
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                $modalInstance.close(data);
            });
        };
    }
]);
